export default "__VITE_ASSET__be1d7221__"